import { BRAND_CONFIG } from '@@brand'
import { OrderPosition } from '@@types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import { formatAmount, formatAmountWithUnitMultiplier } from '@entities/Product/helpers'

import ImageWithBg from '@shared/ui/image-with-bg'
import { formatPrice } from '@shared/uttils'
import { ORDER_POSITION_STATUS } from '@shared/uttils/orderStatus'

import styles from './styles.module.scss'

interface OrderItemProps {
  position: OrderPosition
  onNavToProduct: (productSlug?: string) => void;
}

export default function OrderItem ({ position, onNavToProduct }: OrderItemProps) {
  const { t: t } = useTranslation('order')
  const { t: tc } = useTranslation('common')

  const { changedBy, isChangeTo } = position

  const renderItem = (item: OrderPosition, className?: string) => {
    const statusInfo = item.status
      ? ORDER_POSITION_STATUS[item.status]
      : null

    const hasProduct = !!item.product

    const handleClick = hasProduct ? () => {
      onNavToProduct(item.product?.slug as string)
    } : undefined

    return (
      <div key={item.id} className={classNames(styles.orderItem, className)}>
        <ImageWithBg
          className={classNames(
            styles['orderItem__img'],
            hasProduct && styles['orderItem__img--clickable']
          )}
          src={item.product?.preview?.url ?? BRAND_CONFIG.images.productPlaceholder}
          onClick={handleClick}
        />
        <p
          className={classNames(
            styles['orderItem__text'],
            hasProduct && styles['orderItem__text--clickable']
          )}
          onClick={handleClick}
        >
          {item.name}
        </p>
        <span className={styles['orderItem__description']}>
          { formatAmount({
            product: item.product,
            amount: (item.assembled_count && item.assembled_count > 0 ? item.assembled_count : item.count),
            t: tc,
            showOne: true,
          }) }
        </span>
        {statusInfo && (
          <span
            data-color={statusInfo.color}
            className={styles['orderItem__status']}
          >
            {t(statusInfo.title)}
          </span>
        )}
        <div className={styles['orderItem__price']}>
          <span className={styles['orderItem__price-current']}>
            {formatPrice(item.total ?? 0)}
          </span>
          <span className={styles['orderItem__price-perUnit']}>
            {formatPrice(item.price ?? 0)} / {formatAmountWithUnitMultiplier({
              product: item.product,
              unit_multiplier: item.unit_multiplier,
              t: tc
            })}
          </span>
        </div>
      </div>
    )
  }

  if (changedBy) {
    return (
      <div className={styles.replacement}>
        <div className={styles.replacement__title}>
          <ReactSVG
            className={styles.replacement__icon}
            src="/icons/arrows-left-right.svg"
            width={16}
            height={16}
            wrapper="span"
          />
          <p>{tc('replacement')}</p>
        </div>

        {renderItem(position, styles.replacement__old)}
        {renderItem(changedBy, styles.replacement__new)}
      </div>
    )
  }

  if (isChangeTo) {
    return null
    // (
    //   <div className={styles.replacement}>
    //     <div className={styles.replacement__title}>
    //       <ReactSVG
    //         className={styles.replacement__icon}
    //         src="/icons/arrows-left-right.svg"
    //         width={16}
    //         height={16}
    //         wrapper="span"
    //       />
    //       <p>{tc('replacement')}</p>
    //     </div>
    //     {renderItem(isChangeTo, styles.replacement__old)}
    //     {renderItem(data, styles.replacement__new)}
    //   </div>
    // )
  }

  return renderItem(position)
}